<template>
  <v-dialog
      :id="`dialog_set_metadata`"
      v-model="show"
      max-width="620px"
      @click:outside="cancel"
      @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title class="justify-center">
        <span v-html="title"></span>
      </v-card-title>
      <v-card-text class="justify-center">
        <v-container>
          <v-row align="center">
            <v-col cols="auto">
              <v-combobox
                  ref="metadata_name_selector"
                  :items="metadataNames"
                  :return-object="false"
                  :label="$t('document.setMetadataSearchDialog.metadataName')"
                  v-model="newMetadataName"
              ></v-combobox>
            </v-col>
            <v-col cols="auto">
              <v-combobox
                  ref="metadata_value_selector"
                  :items="metadataKnownValues(newMetadataName)"
                  :return-object="false"
                  :label="$t('document.setMetadataSearchDialog.metadataValue')"
                  v-model="newMetadataValue"
              ></v-combobox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            text
            @click="cancel"
        >
          {{ this.$t("app.button.cancel") }}
        </v-btn>
        <v-btn
            :disabled="!newMetadataName"
            color="primary"
            @click="addNewMetadataOnCurrentList"
        >
          {{ this.$t("app.button.apply") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapState, mapMutations, mapActions} from "vuex";

export default {
  props: ["show", "title", "currentDoc"],
  data() {
    return {
      newMetadataName: null,
      newMetadataValue: null,
    };
  },
  mounted: function () {
    this.fetchMetadata();
  },
  computed: {
    ...mapState("projects", ["metadataDefinition"]),
    ...mapState("document", ["searchParams"]),
    metadataNames() {
      return this.metadataDefinition.map((md) => {
        return {
          text: md.metadata,
          value: md.metadata,
          disabled: !md.isEditable || md.isMultiple,
        };
      });
    },
  },
  methods: {
    ...mapMutations("document", ["setSearchParams"]),
    ...mapActions("projects", ["fetchMetadata"]),
    ...mapActions("document", ["searchAndTagDocuments"]),
    metadataKnownValues(metadataName) {
      let md = this.metadataDefinition.find(
          (md) => md.metadata === metadataName
      );
      if (md !== undefined) {
        return md.knownValues;
      } else {
        return [];
      }
    },
    async addNewMetadataOnCurrentList() {
      this.$refs["metadata_value_selector"].blur();
      this.$refs["metadata_name_selector"].blur();
      this.done();
      // https://stackoverflow.com/questions/63896901/problem-with-updating-model-in-vuetify-combobox
      this.$nextTick(async () => {
        const metadata = {name: this.newMetadataName, value: this.newMetadataValue};
        let params = !this.currentDoc ? this.searchParams : {
          query: `identifier:"${this.currentDoc.identifier}"`,
          isSimpleQueryMode: false
        };
        await this.searchAndTagDocuments({
          params,
          metadata,
        });
      })
    },
    done() {
      this.$emit("done");
    },
    cancel() {
      this.$emit("cancel");
    }
  }
};
</script>